import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router";
import { SignedIn, SignedOut, useUser } from "@clerk/clerk-react";

import CoachPage from "@/pages/CoachPage";
import LoginPage from "@/pages/LoginPage";
import OnboardingPage from "@/pages/OnboardingPage";
import TodayPage from "@/pages/TodayPage";
const AssetsPage = lazy(() => import("@/pages/AssetsPage"));
const JourneyPage = lazy(() => import("@/pages/JourneyPage"));
const LandingPage = lazy(() => import("@/pages/LandingPage"));
const MePage = lazy(() => import("@/pages/MePage"));

function RouteFallback() {
  return <div className="grid h-full place-items-center text-neutral-400 text-sm">…</div>;
}

export default function App() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <SignedOut>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </SignedOut>
      <SignedIn>
        <AuthedApp />
      </SignedIn>
    </Suspense>
  );
}

function AuthedApp() {
  const { user } = useUser();
  if (!user) return null;
  const email = user.primaryEmailAddress?.emailAddress ?? "";
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/today" replace />} />
      <Route path="/login" element={<Navigate to="/today" replace />} />
      <Route path="/today" element={<TodayPage />} />
      <Route path="/onboarding" element={<OnboardingPage />} />
      <Route path="/journey" element={<JourneyPage />} />
      <Route path="/coach" element={<CoachPage userId={user.id} email={email} />} />
      <Route path="/coach/:sessionId" element={<CoachPage userId={user.id} email={email} />} />
      <Route path="/me" element={<MePage />} />
      <Route path="/assets" element={<AssetsPage />} />
      <Route path="*" element={<Navigate to="/today" replace />} />
    </Routes>
  );
}
